import React from 'react';
import { useMediaQueryContext, useModalContext } from '@fourthwall/components';
import { getBonus } from '../../utils';
import { GetFourthwallAppModal } from '../GetFourthwallAppModal';
import { Incentive } from '../Incentive';
export const MobileAppIncentive = ({ incentive }) => {
    const { tablet } = useMediaQueryContext();
    const { open } = useModalContext();
    return (React.createElement(Incentive, { type: incentive.type, icon: "\uD83D\uDCF1", label: "Install our mobile app", isCompleted: incentive.isCompleted, bonus: getBonus(incentive.bonus), button: {
            label: tablet ? 'Install mobile app' : 'Install',
            onClick: () => open(GetFourthwallAppModal),
        } }));
};
